import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const BulletList = ({ contents, ulStyle, liStyle, spanColor }) => {
  return (
    <UnOrderedBulletType style={ulStyle}>
      {contents.map((item, idx) => (
        <UnOrderedBulletItem key={idx} style={liStyle} spanColor={spanColor}>
          {item}
        </UnOrderedBulletItem>
      ))}
    </UnOrderedBulletType>
  );
};

BulletList.propTypes = {
  contents: PropTypes.array.isRequired,
};

export const UnOrderedBulletType = styled.ul`
  ${(props) => props.style}
  list-style-type: disc;
  line-height: ${(props) => props.lineHeight || '1.25rem'};
  padding-inline-start: ${({ paddingInlineStart }) => paddingInlineStart}
  margin-block-start: ${(props) => props.marginBlockStart};
  margin-block-end: ${(props) => props.marginBlockEnd};
  color: ${(props) => props.color};
`;

export const UnOrderedBulletItem = styled.li`
  ${(props) => props.style}
  margin-left: ${(props) => props.marginLeft || '-1rem'};
  padding: ${(props) => props.padding};
  color: ${(props) => props.color || props.theme.color.darkest};
  font-size: ${(props) => props.fontSize};
  font-weight: ${(props) => props.fontWeight};

  span {
    color: ${(props) => props.theme.color[props.spanColor || 'orangePink']};
  }
`;
